const name = require("./name").main;

const description = {
  main: `At ${name}, storytellers and readers form an online community that helps carry forward the most wonderful human experience, the story.`,
  short: "read, write, and share stories",
  startYear: "2019",
};

module.exports = description;
